














import { Component, Vue } from 'vue-property-decorator';
import EachProjectCard from '@/components/organizationDashboard/eachProject/EachProjectCard.vue';

@Component({
  components: {
    EachProjectCard,
  },
})
export default class EachProjectBase extends Vue {
  private model: boolean = false;
  private projectIndex: number = 0;
  private projects: Array<{ title: string; src: any }> = [
    { title: '××プロジェクト', src: require('../../../assets/test.jpeg') },
    { title: '○○プロジェクト', src: require('../../../assets/test.jpeg') },
    { title: '▵▵プロジェクト', src: require('../../../assets/test.jpeg') },
  ];
  private slideProjectCard(index: number): void {
    this.projectIndex = index;
  }
}
